export const DisplayEffectEnum = Object.freeze({
    shadow: 'shadow',
    weatherTime: 'weatherTime',
    object3D: 'object3D',
    water: 'water',
    poi: 'poi'
})